export default "__VITE_ASSET__DPj5I8iI__"